import { RequestService } from '../../../../../common/services/RequestService';
import { GET_ORDER_BY_ID } from '../constants';
import { dataAdjustmentResponse } from '../orderCard/dataAdjustment';

export const getOrderByIdRequest = async (profileId, orderId) => {
  const response = await RequestService.get(
    GET_ORDER_BY_ID.replace('{order_id}', orderId).replace(
      '{profile_id}',
      profileId
    )
  );
  return dataAdjustmentResponse(response.data);
};
